import TechPartnerDetails from './TechPartnerDetails';

export default TechPartnerDetails;
